import Vue from 'vue'
import Vuex from 'vuex'
import { Get } from '@/common/ajax'
import requestUrl from '@/common/api'
import { getStorage, setStorage } from '@/utils/cache/localStorage'
import { USER_INFO } from '@/utils/cache/cacheKey'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menuRoute: {},
    menuRouteTab: [],
    userInfo: {}
  },
  getters: {
    menuRouteData (state) {
      return state.menuRoute
    },
    menuRouteTabData (state) {
      return state.menuRouteTab
    },
    getUserInfoData (state) {
      console.log(state)
      return state.userInfo.id
        ? state.userInfo
        : JSON.parse(getStorage(USER_INFO))
    }
  },
  mutations: {
    setMenuRoute (state, data) {
      state.menuRoute = data
    },
    setMenuRouteTab (state, data) {
      state.menuRouteTab = data
    },
    setUserInfo (state, data) {
      setStorage(USER_INFO, JSON.stringify(data))
      state.userInfo = data
    }
  },
  actions: {
    setUserInfo ({ dispatch, commit }) {
      dispatch('userInfoAction').then(user => {
        commit('setUserInfo', user.data)
      })
    },
    userInfoAction () {
      return Get(requestUrl.userInfo)
    }
  },
  modules: {}
})
